import StepId from "@/model/progress/StepId"

const providerKey = "fortiva_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "fortivaPrequalifyStart",
            path: `/providers/${providerKey}/modes/prequalify/start`,
            redirect: `/providers/${providerKey}/prequalifyAgreeNext`,
        },
        {
            name: "fortivaTerms",
            path: `/providers/${providerKey}/terms`,
            extends: "terms",
            component: () => import("@/views/provider/fortiva/FortivaTermsView.vue"),
        },
        {
            name: "fortivaApproved",
            path: `/providers/${providerKey}/approved`,
            meta: { step: StepId.COMPLETE },
            redirect: `/providers/${providerKey}/complete`,
        },
        {
            path: `/providers/${providerKey}/completeAgreement`,
            name: "fortivaCompleteAgreement",
            extends: "complete",
            component: () => import("@/views/provider/fortiva/FortivaCardholderAgreementView.vue"),
        },
    ],
}
